// import React, { useState } from "react";
// import "./AddArticleSection.scss";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import Editor, {
//   BtnBold,
//   BtnBulletList,
//   BtnClearFormatting,
//   BtnItalic,
//   BtnLink,
//   BtnNumberedList,
//   BtnStrikeThrough,
//   BtnStyles,
//   BtnUnderline,
//   HtmlButton,
//   Separator,
//   Toolbar,
// } from "react-simple-wysiwyg";
// const AddArticleSection = () => {
//   const [value, setValue] = useState("");

//   function onChange(e) {
//     setValue(e.target.value);
//   }
//   const userFormik = useFormik({
//     initialValues: {
//       title: "",
//       category: "",
//       tags: "",
//       version: "",
//     },
//     validationSchema: Yup.object({
//       title: Yup.string().required("Please add Title"),
//       category: Yup.string().required("Please add Category"),
//       tags: Yup.string(),
//       version: Yup.string(),
//     }),
//     onSubmit: (values) => {
//       console.log("Form values:", values);
//       alert(JSON.stringify(values, null, 2));
//     },
//   });
//   return (
//     <>
//       <section className="add-article-page-section">
//         <div className="search-input">
//           <h5 className="form-title">Add Article</h5>
//         </div>
//         <form className="user-info" onSubmit={userFormik.handleSubmit}>
//           <div className="user-inputs">
//             <div className="row">
//               <div className="col-md-4 mt-4">
//                 <div className="floating-label">
//                   <input
//                     type="text"
//                     name="title"
//                     placeholder="e.g. “Terms & Conditions”"
//                     value={userFormik.values.title}
//                     onChange={userFormik.handleChange}
//                     onBlur={userFormik.handleBlur}
//                   />
//                   <label className="floating-label-text">Title</label>
//                   {userFormik.touched.title && userFormik.errors.title && (
//                     <div className="error">{userFormik.errors.title}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mt-4">
//                 <div className="floating-label">
//                   <select
//                     name="category"
//                     value={userFormik.values.category}
//                     onChange={userFormik.handleChange}
//                     onBlur={userFormik.handleBlur}
//                   >
//                     <option value="">Choose Article Type</option>
//                     <option value="Refund Policy">Refund Policy</option>
//                     <option value="Compatibility">Compatibility</option>
//                     <option value="FAQ">FAQ</option>
//                   </select>
//                   <label className="floating-label-text">Category</label>
//                   {userFormik.touched.category &&
//                     userFormik.errors.category && (
//                       <div className="error">{userFormik.errors.category}</div>
//                     )}
//                 </div>
//               </div>
//               <div className="col-md-4 mt-4">
//                 <div className="floating-label">
//                   <select
//                     name="tags"
//                     value={userFormik.values.tags}
//                     onChange={userFormik.handleChange}
//                     onBlur={userFormik.handleBlur}
//                   >
//                     <option value="">Choose Tags to Article</option>
//                     <option value="eSim">eSim</option>
//                     <option value="Flights">Flights</option>
//                     <option value="Hotel">Hotel</option>
//                     <option value="Tours">Tours</option>
//                   </select>
//                   <label className="floating-label-text">Tags (Optional)</label>
//                   {userFormik.touched.tags && userFormik.errors.tags && (
//                     <div className="error">{userFormik.errors.tags}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mt-4">
//                 <div className="floating-label">
//                   <input
//                     type="text"
//                     name="version"
//                     placeholder="e.g. “Terms & Conditions”"
//                     value={userFormik.values.version}
//                     onChange={userFormik.handleChange}
//                     onBlur={userFormik.handleBlur}
//                   />
//                   <label className="floating-label-text">
//                     Version (Optional){" "}
//                   </label>
//                   {userFormik.touched.version && userFormik.errors.version && (
//                     <div className="error">{userFormik.errors.version}</div>
//                   )}
//                 </div>
//               </div>
//               <div className="col-md-4 mt-4">
//                 <div className="status">
//                   <h4>Status</h4>
//                   <div className="checkboxes">
//                     <label className="custom-checkbox">
//                       <input
//                         type="checkbox"
//                         name="status"
//                         value="Draft"
//                         checked={userFormik.values.status === "Draft"}
//                         onChange={() =>
//                           userFormik.setFieldValue("status", "Draft")
//                         }
//                       />
//                       <span className="checkmark"></span>
//                       <span className="name">Draft</span>
//                     </label>

//                     <label className="custom-checkbox">
//                       <input
//                         type="checkbox"
//                         name="status"
//                         value="Published"
//                         checked={userFormik.values.status === "Published"}
//                         onChange={() =>
//                           userFormik.setFieldValue("status", "Published")
//                         }
//                       />
//                       <span className="checkmark"></span>
//                       <span className="name">Published</span>
//                     </label>

//                     <label className="custom-checkbox">
//                       <input
//                         type="checkbox"
//                         name="status"
//                         value="Archived"
//                         checked={userFormik.values.status === "Archived"}
//                         onChange={() =>
//                           userFormik.setFieldValue("status", "Archived")
//                         }
//                       />
//                       <span className="checkmark"></span>
//                       <span className="name">Archived</span>
//                     </label>
//                   </div>
//                 </div>
//               </div>

//               {/* <div className="col-md-4 mt-4">
//                 <div className="status">
//                   <h4>Status</h4>
//                   <div className="checkboxes">
//                     <label className="custom-checkbox">
//                       <input type="checkbox" name="Draft" />
//                       <span className="checkmark"></span>
//                       <span className="name">Draft</span>
//                     </label>
//                     <label className="custom-checkbox">
//                       <input type="checkbox" name="Published" />
//                       <span className="checkmark"></span>
//                       <span className="name">Published</span>
//                     </label>
//                     <label className="custom-checkbox">
//                       <input type="checkbox" name="Archived" />
//                       <span className="checkmark"></span>
//                       <span className="name">Archived</span>
//                     </label>
//                   </div>
//                 </div>
//               </div> */}
//             </div>
//           </div>
//         </form>
//       </section>
//       <section className="add-article-page-section mt-3">
//         <div className="search-input">
//           <h5 className="form-title">Write Article</h5>
//           <div className="modal-icons">
//             <div
//               className="wrapper"
//               data-bs-toggle="modal"
//               data-bs-target="#imageModal"
//             >
//               <img src="/images/icons/img.svg" alt="img" />
//               <p>Add Image</p>
//             </div>
//             <div
//               className="wrapper"
//               data-bs-toggle="modal"
//               data-bs-target="#videoModal"
//             >
//               <img src="/images/icons/camera.svg" alt="video" />
//               <p>Add Video</p>
//             </div>
//             <div
//               className="wrapper"
//               data-bs-toggle="modal"
//               data-bs-target="#gifModal"
//             >
//               <img src="/images/icons/gif.svg" alt="gif" />
//               <p>Add Gif</p>
//             </div>
//           </div>
//         </div>
//         <Editor value={value} onChange={onChange}>
//           <Toolbar>
//             <BtnBold />
//             <BtnItalic />
//             <BtnUnderline />
//             <BtnStrikeThrough />
//             <Separator />
//             <BtnNumberedList />
//             <BtnBulletList />
//             <Separator />
//             <BtnLink />
//             <BtnClearFormatting />
//             <HtmlButton />
//             <Separator />
//             <BtnStyles />
//           </Toolbar>
//         </Editor>
//         <div className="btns">
//           <button
//             className="custom-btn"
//             data-bs-toggle="modal"
//             data-bs-target="#cancelModal"
//           >
//             Delete Article
//           </button>
//           <button className="custom-btn">Edit Article</button>
//         </div>
//         <div
//           className="modal fade"
//           id="cancelModal"
//           tabIndex="-1"
//           aria-labelledby="cancelModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content markup-modal">
//               <div className="modal-body">
//                 <h5 className="modal-title">Delete Article</h5>
//                 <p className="lh-base">
//                   Are you sure you want to remove Article names{" "}
//                   <strong style={{ color: "black" }}>’Privacy Policy’.</strong>{" "}
//                   <br /> this Action will be irreversible!
//                 </p>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 >
//                   Cancel
//                 </button>
//                 <button type="button" className="btn">
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//           className="modal fade"
//           id="imageModal"
//           tabIndex="-1"
//           aria-labelledby="imageModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content article-modal">
//               <div className="modal-body">
//                 <h5 className="modal-title">Upload Image</h5>
//                 <div className="custom-dropzone">
//                   <div className="upload-icon">
//                     <img src="/images/icons/upload-black.svg" alt="Upload" />
//                   </div>
//                   <div className="upload-text">
//                     <h4>Upload Images</h4>
//                     <p>Upload Files in .PNG & .JPEG Format</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 >
//                   Cancel
//                 </button>
//                 <button type="button" className="btn">
//                   Upload
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//           className="modal fade"
//           id="videoModal"
//           tabIndex="-1"
//           aria-labelledby="videoModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content article-modal">
//               <div className="modal-body">
//                 <h5 className="modal-title">Upload Video</h5>
//                 <div className="custom-dropzone">
//                   <div className="upload-icon">
//                     <img src="/images/icons/upload-black.svg" alt="Upload" />
//                   </div>
//                   <div className="upload-text">
//                     <h4>Upload Video</h4>
//                     <p>Upload Files in .MP4 Format</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 >
//                   Cancel
//                 </button>
//                 <button type="button" className="btn">
//                   Upload
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div
//           className="modal fade"
//           id="gifModal"
//           tabIndex="-1"
//           aria-labelledby="gifModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content article-modal">
//               <div className="modal-body">
//                 <h5 className="modal-title">Upload GIF</h5>
//                 <div className="custom-dropzone">
//                   <div className="upload-icon">
//                     <img src="/images/icons/upload-black.svg" alt="Upload" />
//                   </div>
//                   <div className="upload-text">
//                     <h4>Upload GIF</h4>
//                     <p>Upload Files in .GIF Format</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button
//                   type="button"
//                   className="btn"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                 >
//                   Cancel
//                 </button>
//                 <button type="button" className="btn">
//                   Upload
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default AddArticleSection;
import React, { use, useState } from "react";
import "./AddArticleSection.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import Editor, {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  HtmlButton,
  Separator,
  Toolbar,
} from "react-simple-wysiwyg";
import { LocalStorageKeys } from "../../../../constants/LocalStorageKeys";
import { addnewArticle } from "../../../../requests/newArticleAPI";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AddArticleSection = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [gifFile, setGifFile] = useState(null);
  var user = localStorage.getItem(LocalStorageKeys.USER_DETAILS);
  function onChange(e) {
    setValue(e.target.value);
  }

  const userFormik = useFormik({
    initialValues: {
      title: "",
      category: "",
      tags: "",
      version: "",
      status: "Draft",
      media: [],
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please add Title"),
      category: Yup.string().required("Please add Category"),
      tags: Yup.string(),
      version: Yup.string(),
    }),
    onSubmit: async (values) => {
      console.log("Form values:", values);
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("version", values.version);
      formData.append("category", values.category);
      formData.append("tags", values.tags || "");
      formData.append("status", values.status);
      formData.append("content", value || "");
      formData.append("userId", user);

      // Append each file to FormData
      values.media.forEach((file) => {
        formData.append("media", file);
      });
      try {
        const response = await addnewArticle(formData);
        console.log(response);

        if (response?.status == 200 || response?.status == 201) {
          toast.success("Data Added Successfully!");
        } else {
          toast.error("Something Went Wrong!");
        }
      } catch (error) {
        toast.error("Something Went Wrong!");
      } finally {
        navigate("/article-management");
      }
    },
  });
  // const handleFileChange = (e, type) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (type === "image" && !["image/png", "image/jpeg"].includes(file.type)) {
  //     alert("Only PNG and JPEG images are allowed.");
  //     return;
  //   }
  //   if (type === "video" && file.type !== "video/mp4") {
  //     alert("Only MP4 videos are allowed.");
  //     return;
  //   }
  //   if (type === "gif" && file.type !== "image/gif") {
  //     alert("Only GIF files are allowed.");
  //     return;
  //   }

  //   // Normalize current media to an array (handles undefined, single File, or already-array)
  //   let currentMedia = userFormik.values.media;
  //   if (!Array.isArray(currentMedia)) {
  //     if (currentMedia == null) currentMedia = [];
  //     else currentMedia = [currentMedia];
  //   }

  //   // Append the new file
  //   userFormik.setFieldValue("media", [...currentMedia, file]);
  //   console.log("files", userFormik.values.media);

  //   if (type === "image") setImageFile(file);
  //   if (type === "video") setVideoFile(file);
  //   if (type === "gif") setGifFile(file);
  // };
  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (type === "image" && !["image/png", "image/jpeg"].includes(file.type)) {
      alert("Only PNG and JPEG images are allowed.");
      return;
    }
    if (type === "video" && file.type !== "video/mp4") {
      alert("Only MP4 videos are allowed.");
      return;
    }
    if (type === "gif" && file.type !== "image/gif") {
      alert("Only GIF files are allowed.");
      return;
    }

    let currentMedia = Array.isArray(userFormik.values.media)
      ? [...userFormik.values.media]
      : userFormik.values.media
      ? [userFormik.values.media]
      : [];

    // Remove any existing file of the same type
    currentMedia = currentMedia.filter((existingFile) => {
      if (type === "image")
        return (
          !existingFile.type?.startsWith("image/") ||
          existingFile.type === "image/gif"
        );
      if (type === "video") return !existingFile.type?.startsWith("video/");
      if (type === "gif") return existingFile.type !== "image/gif";
      return true;
    });

    // Add new file
    currentMedia.push(file);

    // Update Formik state
    userFormik.setFieldValue("media", currentMedia);

    // Update preview state
    if (type === "image") setImageFile(file);
    if (type === "video") setVideoFile(file);
    if (type === "gif") setGifFile(file);
  };

  const handleUpload = (type) => {
    let file;
    if (type === "image") file = imageFile;
    if (type === "video") file = videoFile;
    if (type === "gif") file = gifFile;

    if (!file) {
      return;
    }
  };
  return (
    <>
      <section className="add-article-page-section">
        <div className="search-input">
          <h5 className="form-title">Add Article</h5>
        </div>
        <form
          id="articleForm"
          className="user-info"
          onSubmit={userFormik.handleSubmit}
        >
          <div className="user-inputs">
            <div className="row">
              <div className="col-md-4 mt-4">
                <div className="floating-label">
                  <input
                    type="text"
                    name="title"
                    placeholder="e.g. “Terms & Conditions”"
                    value={userFormik.values.title}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  />
                  <label className="floating-label-text">Title</label>
                  {userFormik.touched.title && userFormik.errors.title && (
                    <div className="error">{userFormik.errors.title}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-4">
                <div className="floating-label">
                  <select
                    name="category"
                    value={userFormik.values.category}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  >
                    <option value="">Choose Article Type</option>
                    <option value="Refund Policy">Refund Policy</option>
                    <option value="Compatibility">Compatibility</option>
                    <option value="FAQ">FAQ</option>
                    <option value="Installation Step">Installation Step</option>
                  </select>
                  <label className="floating-label-text">Category</label>
                  {userFormik.touched.category &&
                    userFormik.errors.category && (
                      <div className="error">{userFormik.errors.category}</div>
                    )}
                </div>
              </div>
              <div className="col-md-4 mt-4">
                <div className="floating-label">
                  {userFormik.values.category === "Installation Step" ? (
                    <select
                      name="tags"
                      value={userFormik.values.tags}
                      onChange={userFormik.handleChange}
                      onBlur={userFormik.handleBlur}
                    >
                      <option value="">Choose Tags to Article</option>
                      <option value="Direct">Direct</option>
                      <option value="Manual">Manual</option>
                      <option value="QR">QR</option>
                    </select>
                  ) : (
                    <select
                      name="tags"
                      value={userFormik.values.tags}
                      onChange={userFormik.handleChange}
                      onBlur={userFormik.handleBlur}
                    >
                      <option value="">Choose Tags to Article</option>
                      <option value="eSim">eSim</option>
                      <option value="Flights">Flights</option>
                      <option value="Hotel">Hotel</option>
                      <option value="Tours">Tours</option>
                      <option value="Lounge">Lounge</option>
                    </select>
                  )}
                  {/* <select
                    name="tags"
                    value={userFormik.values.tags}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  >
                    <option value="">Choose Tags to Article</option>
                    <option value="eSim">eSim</option>
                    <option value="Flights">Flights</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Tours">Tours</option>
                  </select> */}
                  <label className="floating-label-text">Tags (Optional)</label>
                  {userFormik.touched.tags && userFormik.errors.tags && (
                    <div className="error">{userFormik.errors.tags}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-4">
                <div className="floating-label">
                  <input
                    type="text"
                    name="version"
                    placeholder="e.g. “Terms & Conditions”"
                    value={userFormik.values.version}
                    onChange={userFormik.handleChange}
                    onBlur={userFormik.handleBlur}
                  />
                  <label className="floating-label-text">
                    Version (Optional){" "}
                  </label>
                  {userFormik.touched.version && userFormik.errors.version && (
                    <div className="error">{userFormik.errors.version}</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-4">
                <div className="status">
                  <h4>Status</h4>
                  <div className="checkboxes">
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="status"
                        value="Draft"
                        checked={userFormik.values.status === "Draft"}
                        onChange={() =>
                          userFormik.setFieldValue("status", "Draft")
                        }
                      />
                      <span className="checkmark"></span>
                      <span className="name">Draft</span>
                    </label>

                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="status"
                        value="Published"
                        checked={userFormik.values.status === "Published"}
                        onChange={() =>
                          userFormik.setFieldValue("status", "Published")
                        }
                      />
                      <span className="checkmark"></span>
                      <span className="name">Published</span>
                    </label>

                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="status"
                        value="Archived"
                        checked={userFormik.values.status === "Archived"}
                        onChange={() =>
                          userFormik.setFieldValue("status", "Archived")
                        }
                      />
                      <span className="checkmark"></span>
                      <span className="name">Archived</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
      <section className="add-article-page-section mt-3">
        <div className="search-input">
          <h5 className="form-title">Write Article</h5>
          <div className="modal-icons">
            <div
              className="wrapper"
              data-bs-toggle="modal"
              data-bs-target="#imageModal"
            >
              <img src="/images/icons/img.svg" alt="img" />
              <p>Add Image</p>
            </div>
            <div
              className="wrapper"
              data-bs-toggle="modal"
              data-bs-target="#videoModal"
            >
              <img src="/images/icons/camera.svg" alt="video" />
              <p>Add Video</p>
            </div>
            <div
              className="wrapper"
              data-bs-toggle="modal"
              data-bs-target="#gifModal"
            >
              <img src="/images/icons/gif.svg" alt="gif" />
              <p>Add Gif</p>
            </div>
          </div>
        </div>
        <Editor value={value} onChange={onChange}>
          <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUnderline />
            <BtnStrikeThrough />
            <Separator />
            <BtnNumberedList />
            <BtnBulletList />
            <Separator />
            <BtnLink />
            <BtnClearFormatting />
            <HtmlButton />
            <Separator />
            <BtnStyles />
          </Toolbar>
        </Editor>
        <div className="btns">
          {/* <button
            className="custom-btn"
            data-bs-toggle="modal"
            data-bs-target="#cancelModal"
          >
            Delete Article
          </button> */}
          <button className="custom-btn" type="submit" form="articleForm">
            Add Article
          </button>
        </div>

        {/* IMAGE MODAL */}
        <div
          className="modal fade"
          id="imageModal"
          tabIndex="-1"
          aria-labelledby="imageModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content article-modal">
              <div className="modal-body">
                <h5 className="modal-title">Upload Image</h5>
                <div
                  className="custom-dropzone"
                  onClick={() => document.getElementById("imageInput").click()}
                >
                  <div className="upload-icon">
                    <img src="/images/icons/upload-black.svg" alt="Upload" />
                  </div>
                  <div className="upload-text">
                    <h4>Upload Images</h4>
                    <p>Upload Files in .PNG & .JPEG Format</p>
                    {imageFile && (
                      <small style={{ color: "green" }}>
                        Selected: {imageFile.name}
                      </small>
                    )}
                  </div>
                </div>
                <input
                  type="file"
                  id="imageInput"
                  accept=".png,.jpeg,.jpg"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "image")}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  // type="button"
                  // className="btn"
                  onClick={() => handleUpload("image")}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* VIDEO MODAL */}
        <div
          className="modal fade"
          id="videoModal"
          tabIndex="-1"
          aria-labelledby="videoModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content article-modal">
              <div className="modal-body">
                <h5 className="modal-title">Upload Video</h5>
                <div
                  className="custom-dropzone"
                  onClick={() => document.getElementById("videoInput").click()}
                >
                  <div className="upload-icon">
                    <img src="/images/icons/upload-black.svg" alt="Upload" />
                  </div>
                  <div className="upload-text">
                    <h4>Upload Video</h4>
                    <p>Upload Files in .MP4 Format</p>
                    {videoFile && (
                      <small style={{ color: "green" }}>
                        Selected: {videoFile.name}
                      </small>
                    )}
                  </div>
                </div>
                <input
                  type="file"
                  id="videoInput"
                  accept=".mp4"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "video")}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  // onClick={() => handleUpload("video")}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* GIF MODAL */}
        <div
          className="modal fade"
          id="gifModal"
          tabIndex="-1"
          aria-labelledby="gifModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content article-modal">
              <div className="modal-body">
                <h5 className="modal-title">Upload GIF</h5>
                <div
                  className="custom-dropzone"
                  onClick={() => document.getElementById("gifInput").click()}
                >
                  <div className="upload-icon">
                    <img src="/images/icons/upload-black.svg" alt="Upload" />
                  </div>
                  <div className="upload-text">
                    <h4>Upload GIF</h4>
                    <p>Upload Files in .GIF Format</p>
                    {gifFile && (
                      <small style={{ color: "green" }}>
                        Selected: {gifFile.name}
                      </small>
                    )}
                  </div>
                </div>
                <input
                  type="file"
                  id="gifInput"
                  accept=".gif"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "gif")}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn"
                  // onClick={() => handleUpload("gif")}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddArticleSection;
